import NavigationIcon from "@mui/icons-material/Navigation";
import PinDropIcon from "@mui/icons-material/PinDrop";
import { DateTime } from "luxon";
import { Link } from "react-router-dom";

export function MoveItemInvite({ data: move }) {
  const { estateName, userName: invitedBy, qrImageUrl, location } = move;

  const startDate = DateTime.fromISO(move.startDate, { setZone: true });
  const endDate = DateTime.fromISO(move.endDate, { setZone: true });

  const mapPinLink = `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`;
  const mapDirectionsLink = `https://www.google.com/maps/dir/?api=1&destination=${location.latitude},${location.longitude}`;

  return (
    <div className="tw-grid tw-h-screen tw-overflow-auto">
      <div className="tw-flex tw-flex-col">
        <div
          className="tw-grid"
          style={{
            backgroundColor: "#2032D1",
            backgroundImage:
              'url("https://satrbyzstage.blob.core.windows.net/trbyzstage/images/hexa_spiral.png")',
            backgroundSize: "cover",
          }}
        >
          <div className="tw-mx-auto tw-flex tw-w-full tw-max-w-[700px] tw-flex-col tw-items-start tw-gap-2 tw-p-5 tw-text-white">
            <img
              alt="logo"
              src="https://satrbyzstage.blob.core.windows.net/trbyzstage/images/logo.png"
              className="tw-w-12"
            />
            <span className="tw-mt-5 tw-text-sm tw-font-light">
              {startDate.toLocaleString(DateTime.DATE_FULL)}
            </span>
            <h1 className="tw-text-4xl tw-font-normal tw-text-white">
              Invitation to {estateName}
            </h1>
          </div>
        </div>

        <div className="bg-[#F3F3F3] tw-grid">
          <div className="tw-mx-auto tw-flex tw-max-w-[700px] tw-flex-col tw-gap-5 tw-p-5">
            <p className="tw-m-0">
              You have been invited to move items in {estateName} by {invitedBy}
              . Below are all the necessary information about your invitation
              and security verification check.
            </p>

            <div
              className="border-t-[#2032D1] tw-flex tw-flex-col tw-overflow-hidden tw-rounded-bl-lg tw-rounded-br-lg tw-border-t-2 tw-bg-white tw-shadow"
              style={{ borderTopStyle: "solid" }}
            >
              <img
                alt="qr code"
                src={qrImageUrl}
                className="tw-mx-auto tw-my-12"
                style={{ width: 200, height: 200 }}
              />

              <div className="gap-[1px] bg-[#F3F3F3] tw-grid tw-grid-cols-2">
                <div className="tw-flex tw-flex-col tw-bg-white tw-p-3 tw-font-normal">
                  <span className="tw-text-sm">Start Date:</span>
                  <span className="tw-text-2xl tw-font-medium">
                    {startDate.toLocaleString(DateTime.DATE_FULL)}
                  </span>
                  <span className="tw-text-sm">
                    {startDate.toLocaleString({
                      hour: "numeric",
                      hourCycle: "h12",
                      minute: "2-digit",
                      timeZoneName: "long",
                    })}
                  </span>
                </div>

                <div className="tw-flex tw-flex-col tw-bg-white tw-p-3 tw-text-right tw-font-normal">
                  <span className="tw-text-sm">End Date:</span>
                  <span className="tw-text-2xl tw-font-medium">
                    {endDate.toLocaleString(DateTime.DATE_FULL)}
                  </span>
                  <span className="tw-text-sm">
                    {endDate.toLocaleString({
                      hour: "numeric",
                      hourCycle: "h12",
                      minute: "2-digit",
                      timeZoneName: "long",
                    })}
                  </span>
                </div>

                <div className="tw-col-span-2 tw-flex tw-flex-col tw-bg-white tw-p-3 tw-font-normal">
                  <span className="tw-text-sm">Address</span>
                  <span className="tw-text-xl tw-font-medium">
                    {location.address}
                  </span>
                  <span className="tw-text-sm">{estateName}</span>
                </div>
              </div>
            </div>

            <div className="gap-[1px] tw-grid tw-h-24 tw-grid-cols-2 tw-overflow-hidden tw-rounded-lg tw-shadow">
              <Link
                to={mapPinLink}
                target="_blank"
                rel="noreferrer"
                className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-bg-white tw-text-center"
              >
                <PinDropIcon fontSize="large" htmlColor="#2032D1" />
                <span>Location</span>
              </Link>
              <Link
                to={mapDirectionsLink}
                target="_blank"
                rel="noreferrer"
                className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-bg-white tw-text-center"
              >
                <NavigationIcon fontSize="large" htmlColor="#2032D1" />
                <span>Get Directions</span>
              </Link>
            </div>

            <p className="tw-m-0">
              Please note that {estateName} has strict security measures in
              place to ensure the safety and privacy of our residents. We
              appreciate your cooperation in following these procedures.
              <br />
              <br />
              Thank you for your cooperation, and we look forward to your
              arrival.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
